import React from 'react'

import Form from './Form';

class TypeSection extends React.Component {

  componentDidMount() {
    if (this.props.assetIds.length == 0) {
      this.onNewAssetClick()
    }
  }
  componentDidUpdate() {
    if (this.props.assetIds.length == 0) {
      this.onNewAssetClick()
    }
  }

  title() {
    return I18n.t(`loan_application_user.assets.title.${this.props.assetType}`)
  }

  onNewAssetClick = () => {
    const { assetType } = this.props;
    let key = Date.now() + parseInt(Math.random()*100);

    this.props.onNewAssetClick({
      key: key,
      data: {
        key,
        assetType,
      }
    })
  }

  renderAssetForms() {
    const {
      assetIds,
    } = this.props;

    return assetIds.map((id, index) => (
      <Form
        allowDestroy={ true }
        key={id}
        id={id}
      />
    ))
  }

  render() {
    return(
      <div className='card card-single'>
        <div className='card-header'>
          { this.title() }
        </div>
        <div className='card-body'>
          { this.renderAssetForms() }
          <div
            className='link_underline'
            onClick={ this.onNewAssetClick }
          >
            Add
          </div>
        </div>
      </div>
    )
  }
}

export default TypeSection
